import clsx from 'clsx';

/**
 * Wrapper for clsx
 */
export const cn = (...args: Parameters<typeof clsx>) => {
  const clsxOutput = clsx(...args);

  // Cleans undefined from classname keys when we reference a class that is unavailable for a certain marketplace so they do not end up in the final HTML, as clsx only removes undefined values not keys
  return clsxOutput
    .replace(/\bundefined\b/g, '')
    .replace(/\s+/g, ' ')
    .trim();
};
